<template>
    <div class="pt15">
        <div class="sub_title">
            취소정보
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tbody>
                <tr>
                    <td class="c_t_title">상태</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnStatus() }}
                        </div>
                    </td>
                </tr>
                <tr v-if="checkAdmin()">
                    <td class="c_t_title">취소요청일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.requestDate) }}
                        </div>
                    </td>
                </tr>
                <tr v-if="checkAdmin()">
                    <td class="c_t_title">취소사유</td>
                    <td colspan="3">
                        <div class="d_block">
                            <el-input type="textarea"   v-model="cancelReason" rows="3" readonly
                                      resize="none"></el-input>
                        </div>
                    </td>
                </tr>
                <tr v-if="checkAdmin() && checkUserImage()">
                    <td class="c_t_title">첨부이미지</td>
                    <td colspan="3">
                        <div class="pt10 pb10">
<!--                            <div class="order_img" v-for="(img,index) in orderData.cancelImageFiles" :key="img.a_idx"-->
<!--                                 :style="`background-image:url(${img.org_url})`" @click="showImage()" ></div>-->
                            <image-viewer-component :photos="orderData.cancelImageFiles"></image-viewer-component>
                        </div>
                    </td>
                </tr>
                <!--                승인일때-->
                <tr v-if="orderStatus == 102 || orderStatus == 105">
                    <td class="c_t_title">취소완료일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.doneDate) }}
                        </div>
                    </td>
                </tr>
                <tr v-if="orderStatus == 102 || orderStatus == 105">
                    <td class="c_t_title">취소승인 추가 안내</td>
                    <td colspan="3">
                        <div class="d_block">
                            <div class="d_block">
                                <el-input type="textarea"   v-model="adminReason" rows="3" @input="parentChange('adminReason', adminReason)"
                                          resize="none"></el-input>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--                거절일때-->
                <tr v-if="orderData.cancelStatus == 2">
                    <td class="c_t_title">취소철회일</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ returnDateTimeFormat(orderData.cancelRejectDate) }}
                        </div>
                    </td>
                </tr>
                <tr v-if="orderData.cancelStatus == 2">
                    <td class="c_t_title">거절사유</td>
                    <td colspan="3">
                        <div class="d_block">
                            <div class="d_block">
                                <el-input type="textarea" readonly v-model="adminReason" rows="3" @input="parentChange('adminReason', adminReason)"
                                          resize="none"></el-input>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import orderMixins from "@/mixins/orderMixins";
import SimpleVueValidation from "simple-vue-validator";
import Vue from "vue";
const Validator = SimpleVueValidation.Validator;
import EventBus from "@/mixins/event-bus";
import ImageViewerComponent from "@/components/image/ImageViewerComponent";

Vue.use(SimpleVueValidation);
export default {
    name: "OrderCancelLayout",
    mixins: [dateMixins, orderMixins],
    components: {ImageViewerComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        orderData: {
            default: () => {
            }, type: Object
        },
        orderClass: {default: null,},
    },
    data() {
        return {
            adminReason : '',
            cancelReason : '',

            orderStatus : '',
            validatorArr: ['adminReason','cancelReason'],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initData()
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('OrderCancelLayout')
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initData(){
            if(!util.isEmpty(this.orderData)){
                this.cancelReason = this.orderData.cancelReason
                this.adminReason = this.orderData.adminReason
                this.orderStatus = this.orderData.orderStatus
            }
        },
        checkImage(){
            if(!util.isEmpty(this.orderData.itemFiles) && !util.isEmpty(this.orderData.itemFiles[0].a_idx)){
                return this.orderData.itemFiles[0].org_url
            }
        },
        returnStatus(){
            let key = this.orderData.cancelStatus;
            return this.returnCancelStatus(key);
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        checkValidator() {
            this.$validate(['adminReason','cancelReason'])
        },
        checkAdmin(){
            if(this.orderData.orderMember === this.orderData.cancelMember){
                return true
            }
        },
        checkUserImage(){
            if(!util.isEmpty(this.orderData) && !util.isEmpty(this.orderData.cancelImageFiles)){
                return true
            }
        },
        showImage(){
            EventBus.$emit('runShow')
        }
    },
    watch: {},
    validators: {
        cancelReason: function (value) {
            return Validator.value(value)
        },
        adminReason: function (value) {
            return Validator.value(value)
        },
    }
}
</script>

<style scoped>

</style>
